import { render, staticRenderFns } from "./ActionsInvitesUBA.vue?vue&type=template&id=67823838&scoped=true&"
import script from "./ActionsInvitesUBA.vue?vue&type=script&lang=js&"
export * from "./ActionsInvitesUBA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67823838",
  null
  
)

export default component.exports